module.exports = __webpack_public_path__ + "static/media/sound_proof_recording_room.39534075.jpeg";